import {
  BffResponse,
  ModelFilter,
} from '@volkswagen-onehub/car-technical-details-bff';

export const createBffUrl = (options: {
  baseUrl: string;
  language: string;
  countryCode: string;
  endpoint: string;
  showroomNodeId?: string;
  models?: ModelFilter[];
  apiKey: string;
  cacheBustingAllowed: boolean;
  mockIds?: string[];
  mocksServerName?: 'global' | 'local';
  debug?: string;
  dimensionImagesTrim?: string;
  defaultTrim?: string;
}): string => {
  const params = new URLSearchParams();
  params.append('language', options.language);
  params.append('countryCode', options.countryCode);
  params.append('endpoint', options.endpoint);
  if (options.debug) {
    params.append('debug', options.debug);
  }
  params.append('oneapiKey', options.apiKey);
  params.append('cacheBustingAllowed', String(options.cacheBustingAllowed));
  if (options.debug) {
    params.append('debug', options.debug);
  }
  if (options.showroomNodeId)
    params.append('showroomNodeId', options.showroomNodeId);
  if (options.models && options.models.length > 0) {
    params.append('models', JSON.stringify(options.models));
  }
  if (options.mockIds) {
    params.append('mockIds', options.mockIds.join('-'));
  }
  if (options.mocksServerName) {
    params.append('mocksServerName', options.mocksServerName);
  }
  if (options.dimensionImagesTrim) {
    params.append('dimensionImagesTrim', options.dimensionImagesTrim);
  }
  if (options.defaultTrim) {
    params.append('defaultTrim', options.defaultTrim);
  }

  return `${options.baseUrl}/bff?${params.toString()}`;
};

export async function loadBff(url: string): Promise<BffResponse> {
  const response = await fetch(url);

  if (response.status !== 200) {
    throw new Error('Failed to load bff data: ' + response.statusText);
  }
  return await response.json();
}
